import { getRequest, postRequest, putRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getEmploymentStatusListRequest = () =>
  getRequest(replaceInUrl(apiEndpoints.employment.getStatusList));

export const getOccupationCategoriesRequest = () =>
  getRequest(replaceInUrl(apiEndpoints.employment.getOccupationCategories));

export const getOccupationCategoryInfoRequest = ({ OccupationCategory }) =>
  getRequest(
    replaceInUrl(apiEndpoints.employment.getOccupationCategory, {
      OccupationCategory,
    }),
  );

export const getEmploymentInfoRequest = ({ ApplicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.employment.info, {
      ApplicationUid,
    }),
  );

export const postEmploymentInfoRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.employment.info, {
      ApplicationUid,
    }),
    data,
  );

export const putEmploymentInfoRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.employment.info, {
      ApplicationUid,
    }),
    data,
  );

// Source of Income Requests
export const getIncomeSourceRequest = () =>
  getRequest(replaceInUrl(apiEndpoints.employment.incomeSource));
